const DIVISIONS: { amount: number; unit: Intl.RelativeTimeFormatUnit }[] = [
  { amount: 60, unit: 'second' },
  { amount: 60, unit: 'minute' },
  { amount: 24, unit: 'hour' },
  { amount: 7, unit: 'day' },
  { amount: 4.34524, unit: 'week' },
  { amount: 12, unit: 'month' },
  { amount: Number.POSITIVE_INFINITY, unit: 'year' },
]

const formatter = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' })

export type FormatRelativeTimeArgs = {
  iso: string
}

export const formatRelativeTime = ({ iso }: FormatRelativeTimeArgs): string => {
  const elapsed = (new Date(iso).getTime() - Date.now()) / 1000

  const result = DIVISIONS.reduce(
    (acc, division) => {
      if (acc.done) {
        return acc
      }

      if (Math.abs(acc.value) < division.amount) {
        return { done: true, value: acc.value, unit: division.unit }
      }

      return {
        done: false,
        value: acc.value / division.amount,
        unit: division.unit,
      }
    },
    {
      done: false,
      value: elapsed,
      unit: 'second' as Intl.RelativeTimeFormatUnit,
    },
  )

  return formatter.format(Math.round(result.value), result.unit)
}
